$('[data-toggle="dialog"]').each(function () {
    const $toggle = $(this),
        $dialog = $('dialog[data-dialog-id="' + $toggle.attr('data-dialog-id') + '"]');

    if ($dialog.length > 0) {
        $toggle[0].addEventListener('click', () => {
            $dialog[0].showModal();
            $('.page-wrapper').trigger('lenisStop');
        });
    }
});

$('.dialog--auto-open').each(function () {
    let $dialog = $(this),
        cookie = false;

    if ('undefined' === typeof delay || !delay) {
        delay = 0;
    }

    if ($dialog.hasClass('dialog--has-cookie')) {
        // check if modal has cookie

        let cookieHash = 'dialog_'+ $dialog.data('cookie-hash'), // based on modal content, so if content changes, modal will be shown again
            cookieDuration = $dialog.data('cookie-duration');

        if (Cookies.get(cookieHash)) {
            // check if cookie exists - if so, dont show modal and remove from DOM completely
            $dialog.remove();
            cookie = true; 
        } else {
            if (typeof cookieDuration !== 'undefined' && typeof cookieHash !== 'undefined') {
                setCookie(cookieHash, 1, cookieDuration);
            }
        }
    }

    setTimeout(function () {
        $('dialog').each(function () {
            if ($(this).attr('open')) {
                $(this)[0].close();
            }
        });
        
        if (!cookie) { // extra check needed for when only one dialog is present in DOM
            $dialog[0].showModal();
            $('.page-wrapper').trigger('lenisStop');
        }
    }, delay);
});

$('.dialog__close').on('click', function () {
    let $dialog = $(this).closest('.dialog');

    $dialog[0].close();
    $('.page-wrapper').trigger('lenisStart');
});

// close on backdrop click
$('.dialog').on('click', function (e) {
    let $dialog = $(this);

    let rect = $dialog[0].getBoundingClientRect(),
        isInDialog = (rect.top <= e.clientY && e.clientY <= rect.top + rect.height && rect.left <= e.clientX && e.clientX <= rect.left + rect.width);

    if (!isInDialog) {
        $dialog[0].close();
        $('.page-wrapper').trigger('lenisStart');
    }
});

// close on form button
$('.dialog form').on('submit', function () {
    $('.page-wrapper').trigger('lenisStart');
});
